import apiService from '../apiService';

const DestinationsService = {
  listDestination: (params) => apiService.get('/destinations', params),
  getDestination: (id) => apiService.get(`/destinations/${id}`),
  createDestination: (data) => apiService.post('/destinations', data),
  updateDestination: (id, data) => apiService.put(`/destinations/${id}`, data),
  deleteDestination: (id) => apiService.delete(`/destinations/${id}`),
};

export default DestinationsService;
